import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "selector"
};
const _hoisted_2 = {
  class: "ml-2 flex flex-wrap"
};
const _hoisted_3 = ["title", "onClick"];
import { computed, ref, toRef, watch } from 'vue';
import { cloneDeep } from 'lodash-es';
import { IconJson } from '@/components/Icon/src/data';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'IconSelect'
  },
  __name: 'IconSelect',
  props: {
    modelValue: {
      require: false,
      type: String
    },
    clearable: {
      require: false,
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const visible = ref(false);
    const inputValue = toRef(props, 'modelValue');
    const iconList = ref(IconJson);
    const icon = ref('add-location');
    const currentActiveType = ref('ep:');
    // 深拷贝图标数据，前端做搜索
    const copyIconList = cloneDeep(iconList.value);
    const pageSize = ref(96);
    const currentPage = ref(1);
    // 搜索条件
    const filterValue = ref('');
    const tabsList = [{
      label: 'Element Plus',
      name: 'ep:'
    }, {
      label: 'Font Awesome 4',
      name: 'fa:'
    }, {
      label: 'Font Awesome 5 Solid',
      name: 'fa-solid:'
    }];
    const pageList = computed(() => {
      if (currentPage.value === 1) {
        return copyIconList[currentActiveType.value]?.filter(v => v.includes(filterValue.value)).slice(currentPage.value - 1, pageSize.value);
      } else {
        return copyIconList[currentActiveType.value]?.filter(v => v.includes(filterValue.value)).slice(pageSize.value * (currentPage.value - 1), pageSize.value * (currentPage.value - 1) + pageSize.value);
      }
    });
    const iconCount = computed(() => {
      return copyIconList[currentActiveType.value] == undefined ? 0 : copyIconList[currentActiveType.value].length;
    });
    const iconItemStyle = computed(() => {
      return item => {
        if (inputValue.value === currentActiveType.value + item) {
          return {
            borderColor: 'var(--el-color-primary)',
            color: 'var(--el-color-primary)'
          };
        }
      };
    });
    function handleClick({
      props
    }) {
      currentPage.value = 1;
      currentActiveType.value = props.name;
      emit('update:modelValue', currentActiveType.value + iconList.value[currentActiveType.value][0]);
      icon.value = iconList.value[currentActiveType.value][0];
    }
    function onChangeIcon(item) {
      icon.value = item;
      emit('update:modelValue', currentActiveType.value + item);
      visible.value = false;
    }
    function onCurrentChange(page) {
      currentPage.value = page;
    }
    function clearIcon() {
      icon.value = '';
      emit('update:modelValue', '');
      visible.value = false;
    }
    watch(() => {
      return props.modelValue;
    }, () => {
      if (props.modelValue && props.modelValue.indexOf(':') >= 0) {
        currentActiveType.value = props.modelValue.substring(0, props.modelValue.indexOf(':') + 1);
        icon.value = props.modelValue.substring(props.modelValue.indexOf(':') + 1);
      }
    });
    watch(() => {
      return filterValue.value;
    }, () => {
      currentPage.value = 1;
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_ElInput = _resolveComponent("ElInput");
      const _component_ElDivider = _resolveComponent("ElDivider");
      const _component_ElScrollbar = _resolveComponent("ElScrollbar");
      const _component_ElTabPane = _resolveComponent("ElTabPane");
      const _component_ElTabs = _resolveComponent("ElTabs");
      const _component_ElPagination = _resolveComponent("ElPagination");
      const _component_ElPopover = _resolveComponent("ElPopover");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_ElInput, {
        modelValue: inputValue.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => inputValue.value = $event),
        onClick: _cache[4] || (_cache[4] = $event => visible.value = !visible.value),
        clearable: props.clearable,
        onClear: clearIcon
      }, {
        append: _withCtx(() => [_createVNode(_component_ElPopover, {
          "popper-options": {
            placement: 'auto'
          },
          visible: visible.value,
          width: 355,
          "popper-class": "pure-popper",
          trigger: "click"
        }, {
          reference: _withCtx(() => [_createElementVNode("div", {
            class: "h-32px w-40px flex cursor-pointer items-center justify-center",
            onClick: _cache[0] || (_cache[0] = $event => visible.value = !visible.value)
          }, [_createVNode(_component_Icon, {
            icon: currentActiveType.value + icon.value
          }, null, 8, ["icon"])])]),
          default: _withCtx(() => [_createVNode(_component_ElInput, {
            modelValue: filterValue.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filterValue.value = $event),
            class: "p-2",
            clearable: "",
            placeholder: "搜索图标"
          }, null, 8, ["modelValue"]), _createVNode(_component_ElDivider, {
            "border-style": "dashed"
          }), _createVNode(_component_ElTabs, {
            modelValue: currentActiveType.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => currentActiveType.value = $event),
            onTabClick: handleClick
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabsList, (pane, index) => {
              return _createVNode(_component_ElTabPane, {
                key: index,
                label: pane.label,
                name: pane.name
              }, {
                default: _withCtx(() => [_createVNode(_component_ElDivider, {
                  "border-style": "dashed",
                  class: "tab-divider"
                }), _createVNode(_component_ElScrollbar, {
                  height: "220px"
                }, {
                  default: _withCtx(() => [_createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageList.value, (item, key) => {
                    return _openBlock(), _createElementBlock("li", {
                      key: key,
                      style: _normalizeStyle(iconItemStyle.value(item)),
                      title: item,
                      class: "icon-item mr-2 mt-1 w-1/10 flex cursor-pointer items-center justify-center border border-solid p-2",
                      onClick: $event => onChangeIcon(item)
                    }, [_createVNode(_component_Icon, {
                      icon: currentActiveType.value + item
                    }, null, 8, ["icon"])], 12, _hoisted_3);
                  }), 128))])]),
                  _: 1
                })]),
                _: 2
              }, 1032, ["label", "name"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_ElDivider, {
            "border-style": "dashed"
          }), _createVNode(_component_ElPagination, {
            "current-page": currentPage.value,
            "page-size": pageSize.value,
            total: iconCount.value,
            background: "",
            class: "h-10 flex items-center justify-center",
            layout: "prev, pager, next",
            size: "small",
            onCurrentChange: onCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      }, 8, ["modelValue", "clearable"])]);
    };
  }
});